<wl-email
  [formsControl]="control"
  [rendering]="{ componentName: trackStep.toolName }"
  [label]="fields.Label?.value"
  [placeholder]="fields.Placeholder?.value"
  [step]="trackStep.step"
  [stepName]="trackStep.stepName"
  [fieldName]="fields.Label?.value"
  [tooltip]="fields.Tooltip?.value"
  [hashValue]="fields.HashValue?.value"
  [sendValue]="fields.SendValue?.value"
  [wlAutocomplete]="!isEmailValidation && 'email'"
  [wlAutocompleteDisabled]="isEmailValidation"
  [preventPaste]="isEmailValidation"
  [floatingLabel]="floatingLabel"
></wl-email>
